<template>
  <b-row>
    <b-col cols="6" class="pr-0">
      <div class="mb-4" @click="asyncFindCondition('')" v-if="satusehatAuthValid">
        <label for="condition" class="text-subtitle">Kondisi</label>
        <multiselect
          v-model="selectedCondition"
          :options="optionCondition"
          :multiple="true"
          placeholder="Pilih Kondisi"
          label="label"
          track-by="label"
          :loading="isLoadingCondition"
          :hide-selected="true"
          :options-limit="10"
          :limit="10"
          open-direction="bottom"
          :limit-text="limitText"
          @search-change="debounceCondition($event)">
        </multiselect>
      </div>
        
      <b-row>
        <b-col id="dgKodePenyakit" cols="5" class="pr-0 mb-5 multiselect_primary" @click="asyncFind('', 'primary')">
          <label for="primary" class="text-subtitle">Pilih kode Diagnosis Primer<span class="text-danger" v-if="!icdxOodontogram">*</span></label>
          <multiselect
            v-model="selectedKodePenyakitPrimer"
            :options="kodePenyakitPrimer"
            placeholder="Pilih Kode Diagnosis"
            label="kode"
            track-by="kode"
            open-direction="bottom"
            :multiple="false"
            :loading="isLoading"
            :clear-on-select="true"
            :close-on-select="false"
            :options-limit="10"
            :hide-selected="true"
            @search-change="debounceSearch($event, 'primary')">
          </multiselect>
        </b-col>
        <b-col id="dgNamaPenyakit" cols="7" class="mb-5 multiselect_primary" @click="asyncFind('', 'primary')">
          <label for="primary" class="text-subtitle">Pilih Diagnosis Primer<span class="text-danger" v-if="!icdxOodontogram">*</span></label>
          <multiselect
            v-model="selectedKodePenyakitPrimer"
            :options="kodePenyakitPrimer"
            :multiple="false"
            placeholder="Pilih Diagnosis"
            label="description"
            track-by="description"
            :loading="isLoading"
            :hide-selected="true"
            :options-limit="10"
            :limit="3"
            open-direction="bottom"
            :limit-text="limitText"
            @search-change="debounceSearch($event, 'primary')">
          </multiselect>
        </b-col>

        <b-col
          id="dgKodePenyakitSecondary"
          cols="5"
          class="pr-0"
          @click="asyncFind('', 'secondary')"
        >
          <label for="secondary" class="text-subtitle">Pilih kode Diagnosis Sekunder</label>
          <multiselect
            v-model="selectedKodePenyakit"
            :options="kodePenyakit"
            placeholder="Pilih Kode Diagnosis"
            label="kode"
            track-by="kode"
            open-direction="bottom"
            :multiple="true"
            :loading="isLoading"
            :clear-on-select="false"
            :close-on-select="false"
            :options-limit="10"
            :hide-selected="true"
            @search-change="debounceSearch($event, 'secondary')">
          </multiselect>
        </b-col>
        <b-col
          id="dgNamaPenyakitSecondary"
          cols="7"
          @click="asyncFind('', 'secondary')"
        >
          <label for="secondary" class="text-subtitle">Pilih Diagnosis Sekunder</label>
          <multiselect
            v-model="selectedKodePenyakit"
            :options="kodePenyakit"
            :multiple="true"
            placeholder="Pilih Diagnosis"
            label="description"
            track-by="description"
            :loading="isLoading"
            :hide-selected="true"
            :options-limit="10"
            :limit="3"
            open-direction="bottom"
            :limit-text="limitText"
            @search-change="debounceSearch($event, 'secondary')">
          </multiselect>
        </b-col>

        <b-col cols="12" class="mt-5">
          <b-form-group
            class="text-capitalize"
            style="position: relative"
          >
            <label class="text-subtitle">
              Prognosa<span class="text-danger" v-if="this.checkValueData(this.trx) && this.trx.kategori_id == 2">*</span>
            </label>
            <br />
            <template>
              <vue-select
                id="prognosa"
                keyOpt="prognosa"
                :class="{'select-invalid': prognosa.error}"
                :options="prognosa.option"
                v-model="prognosa.data"
                class="__select-prognosa mt-2"
                placeholder="Pilih Prognosa"
                @input="setPrognosa($event)"
              >
              </vue-select>
              <b-form-invalid-feedback class="text-lowercase" :state="!prognosa.error">
                Kolom wajib diisi
              </b-form-invalid-feedback>
            </template>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="6" class="pr-0">
      <b-row>
        <b-col cols="12" class="row">
          <b-col cols="3" class="text-subtitle">
            <label>Catatan:</label>
          </b-col>
          <b-col cols="9" class="float-right pen-isMobile">
            <div class="row d-flex justify-content-end mr-2">
              <div class="mt-2">
                <span @click="penColor('blue');isColorActive = 'blue'" class="dot grow" style="background-color: blue;"
                  :class="{ color_active: isColorActive === 'blue' }"></span>
                <span @click="penColor('red');isColorActive = 'red'" class="dot grow" style="background-color: red;"
                  :class="{ color_active: isColorActive === 'red' }"></span>
                <span @click="penColor('#54c756');isColorActive = 'green'" class="dot grow"
                  style="background-color: #54c756;" :class="{ color_active: isColorActive === 'green' }"></span>
                <span @click="penColor('#555');isColorActive = 'black'" class="dot grow" style="background-color: #555;"
                  :class="{ color_active: isColorActive === 'black' }"></span>
                <span @click="penColor('orange');isColorActive = 'yellow'" class="dot grow"
                  style="background-color: orange;" :class="{ color_active: isColorActive === 'yellow' }"></span>
              </div>
              <font-awesome-icon
                icon="eraser"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostData('eraser');"
                v-show="!isHidden"
                :class="{ active_tool: isActive === 'eraser' }" />
              <font-awesome-icon
                icon="pen-alt"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostData('pen');"
                :class="{ active_tool: isActive === 'pen' }" />
              <font-awesome-icon
                icon="keyboard"
                class="font-size-xl m-2 grow icon"
                v-on:click="setDrawPostData('keyboard');"
                  :class="{ active_tool: isActive === 'keyboard' }" />
            </div>
            <div class="row d-flex justify-content-end mr-2">
              <input type="range" class="custom-range pen-width" min="1" max="50" v-model.number="penWidth" />
            </div>
          </b-col>
        </b-col>
        <b-col cols="12" v-show="!isHidden">
          <canvas
            id="diagnosa-canvas"
            ref="canvas"
            @mousedown="handleMousedown"
            @mouseup="handleMouseup"
            @mousemove="handleMousemove"
            @touchstart="handleTouchstart"
            @touchend="handleTouchend"
            @touchmove="handleTouchmove"
            :width="canvasWidth"
            :height="canvasHeight"
          >
            Your browser does not support the HTML 5 Canvas.
          </canvas>
        </b-col>
        <b-col cols="2" v-show="!isHidden">
          <b-button @click="clear" variant="warning" size="sm" class="m-1">Clear</b-button>
        </b-col>

        <b-col cols="12" v-show="isHidden">
          <Editor
            :editorContent="diagnosa"
            :height="editorHeight"
            :width="contentWidth"
            v-on:update-content="updateContent"
            class="form-diagnosa"
          />
        </b-col>
        <b-col cols="12" v-show="!isHidden">
          <div id="img_diagnosa"></div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import debounce from 'lodash/debounce';
  import rekamMedisMixin from '../mixins';

  export default {
    name: 'AssessmentDiagnosa',
    mixins: [rekamMedisMixin],
    props: ['icdxOodontogram'],
    components: {
      Multiselect: () => import('vue-multiselect'),
      Editor: () => import('./Editor.vue'),
      'vue-select': () => import('@/components/VueSelectClearable.vue'),
    },
    data() {
      return {
        // selected: '',
        isDrawing: false,
        isHidden: true,
        drawing: false,
        mousePos: {
          x: 0,
          y: 0
        },
        lastPos: {
          x: 0,
          y: 0
        },
        ctx: null,
        isLoading: false,
        selectedKodePenyakitPrimer: null,
        selectedKodePenyakit: [],
        kodePenyakitPrimer: [],
        kodePenyakit: [],
        isPen: false,
        isActive: 'keyboard',
        isColorActive: 'black',
        penWidth: 2,        
        ediRekamMedis: {},
        diagnosa: null,
        imgDiagnosa: null,
        keyword: null,
        keywordCondition: null,
        isLoadingCondition: false,
        selectedCondition: [],
        optionCondition: [],
        hasEncounterSatusehat: false,
        prognosa: {
          option: [],
          data: null,
          error: null,
        },
        contentWidth: 675,
        canvasHeight: 160,
        canvasWidth: 675,
        editorHeight: 150,
      };
    },
    watch: {
      '$store.state.rekamMedis.transaksi': {
        handler: function() {
         this.hasEncounterSatusehat = this.$store.state.rekamMedis.transaksi.satusehat_encounter_id ? true: false;
        },
        deep: true
      },
      selectedKodePenyakitPrimer: function () {        
        this.updatePostData({
          key: 'kode_penyakit_primary',
          value: this.selectedKodePenyakitPrimer
        });
      },
      selectedKodePenyakit: function () {        
        //jika ada kode diagnosis lainya
        this.selectedKodePenyakit.map(res => {
          if (res.kode == 'IZDOTHER') {
            //langsung scroll
            window.scrollTo({
              top: 600,
              behavior: 'smooth'
            });
          }
        });

        this.updatePostData({
          key: 'kode_penyakit',
          value: this.selectedKodePenyakit
        });
      },
      imgDiagnosa() {
        this.imgDiagnosaChanged();
      },
      collapsed() {
        setTimeout(() => {
          this.resizeWidth(this.collapsed);
          this.imgDiagnosa = this.canvas_diagnosa ? this.canvas_diagnosa.toDataURL('image/png') : null;
        }, 500);
      },
      collapsedMobile() {
        setTimeout(() => {
          this.resizeWidth(this.collapsedMobile);
          this.imgDiagnosa = this.canvas_diagnosa ? this.canvas_diagnosa.toDataURL('image/png') : null;
        }, 500);
      },
      orientation() {
        setTimeout(() => {
          this.resizeWidth(this.collapsedMobile);
          this.imgDiagnosa = this.canvas_diagnosa ? this.canvas_diagnosa.toDataURL('image/png') : null;
        }, 500);
      },
      selectedCondition: function () {
        let con = [];
        if (this.selectedCondition && this.selectedCondition.length > 0) {
          con = this.selectedCondition.map(c => c.id);
        }      
        this.updatePostData({
          key: 'condition_ids',
          value: con,
        });
      },
    },
    computed: {
      ...mapState(['sidebar']),
      ...mapGetters('sidebar', ['collapsed', 'collapsedMobile', 'orientation']),
    ...mapGetters(['getKlinikId', 'saving_params', 'postData', 'canvas_diagnosa', 'satusehatAuthValid', 'trx']),
      canvas() {
        return this.$refs.canvas;
      }
    },
    async mounted() {
      await this.resizeWidth(this.collapsed);
    
      this.ctx = this.canvas.getContext('2d');
      this.ctx.strokeStyle = '#222222';
      this.ctx.lineWidth = this.penWidth;
      this.ctx.lineJoin = 'round';
      this.ctx.lineCap = 'round';

      // initial value for handle error view rujukan
      this.updatePostData({
        key: 'kode_penyakit_primary',
        value: this.selectedKodePenyakitPrimer
      });
      this.updatePostData({
        key: 'kode_penyakit',
        value: this.selectedKodePenyakit
      });

      //append data canvas to vuex global state
      this.updateCanvas({
        key: 'DIAGNOSA',
        value: this.canvas
      });
      this.updatePostData({
        key: 'diagnosa_is_draw',
        value: false
      });

      // Get a regular interval for drawing to the screen
      window.requestAnimFrame = (function (callback) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function (callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();
      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        'touchstart',
        function (e) {
          if (e.target == document.getElementById('diagnosa-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchend',
        function (e) {
          if (e.target == document.getElementById('diagnosa-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchmove',
        function (e) {
          if (e.target == document.getElementById('diagnosa-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      if (this.prognosa.option.length < 1) this.prognosa.option = await this.fetchPrognosa(this.getKlinikId);

      this.ediRekamMedis = localStorage.getItem('edit_rekam_medis');
      if(this.ediRekamMedis != null) this.setDiagnosaData(JSON.parse(this.ediRekamMedis));
    },
    methods: {
      ...mapActions(['updatePostData', 'updateCanvas']),
      updateContent(content) {
        this.updatePostData({
          key: 'diagnosa_text',
          value: content
        });
      },
      resizeWidth(collapsed = false) {
        let elRM = document.getElementById('rekam_medis_klinik');

        let w = elRM.offsetWidth;
        let x = 1;

        if (w > 1400) x = 2.335;
        else if (collapsed) {
          if (this.orientation == 'portrait') x = 2.85;
          else {
            if (w < 1024) x = 2.9;
            else x = 2.55;
          }
        } else {
          if (this.orientation == 'portrait') x = 2.816;
          else {
            if (w < 750) x = 2.84;
            else if (w < 1024) x = 2.445;
            else x = 1.964;
          }
        }

        this.canvasWidth = this.contentWidth = w / x;
        this.canvasHeight = this.canvasWidth * 0.5;
        this.editorHeight = this.canvasHeight;
      },
      setDiagnosaData(d) {
        if (d.diagnosa && d.diagnosa.is_draw) {
          this.diagnosa = d.diagnosa.notes
          if (d.diagnosa.draw_path != null) {
            this.imgDiagnosa = d.diagnosa.draw_path;
            this.updatePostData({
              key: 'diagnosa_is_draw',
              value: true
            });
          }
        } else {
          this.diagnosa = d.diagnosa ? d.diagnosa.notes : null;
        }
        if (d.diagnosa.kode_penyakit_id == '[]' || d.diagnosa.kode_penyakit_id == '') {
          this.selected = null;
          this.selectedKodePenyakitPrimer = null
          this.selectedKodePenyakit = []
        } else if (d.diagnosa.kode_penyakit_id == '[34335]') {
          this.selected = 'Normal/Sehat/tidak ada kelainan'
        } else {
          this.selected = 'B'
          this.selectedKodePenyakitPrimer = d.kode_diagnosa_primary
          this.selectedKodePenyakit = d.kode_diagnosa
        }
        if (d.bpjs_health_data) this.prognosa.data = this.prognosa.option.find(opt => opt.value == d.bpjs_health_data.kd_prognosa);
        if (d.condition_ids && d.condition_ids.length > 0) {
          this.selectedCondition = d.condition_ids;
        }
      },
      imgDiagnosaChanged() {
        let self = this;
        self.image_url = self.imgDiagnosa;
        self.clear();
        self.drawBackground(self.image_url);
      },
      // draw the image
      drawBackground(image_url) {
        let self = this;
        let canvas = document.getElementById('diagnosa-canvas'),
          ctx = canvas.getContext('2d'),
          img_diagnosa = document.getElementById('img_diagnosa');
        let backgroundURL = image_url;

        let background = new Image();
        background.crossOrigin = 'Anonymous';
        background.src = backgroundURL;

        //remove existing image
        if (img_diagnosa.hasChildNodes()) {
          img_diagnosa.innerHTML = '';
        }

        background.onload = function() {
          let newSize = { width: self.canvasWidth, height: self.canvasHeight };
          ctx.drawImage(background, 0, 0, newSize.width, newSize.height);
        };
        this.isDrawing = true;
      },
      handleMousedown(e) {
        this.lastPos = this.getMousePos(e);
        this.ctx.lineWidth = this.penWidth;
        this.drawing = true;
      },
      handleMouseup(e) {
        this.drawing = false;
      },
      handleMousemove(e) {
        this.mousePos = this.getMousePos(e);
        if (this.drawing) {
          this.ctx.beginPath();
          if (this.isPen) {
            this.ctx.globalCompositeOperation = 'source-over';
            this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
            this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
            this.ctx.stroke();
          } else {
            this.ctx.globalCompositeOperation = 'destination-out';
            this.ctx.arc(
              this.mousePos.x,
              this.mousePos.y,
              this.penWidth,
              0,
              Math.PI * 2,
              false
            );
            this.ctx.fill();
          }
          this.lastPos = this.mousePos;
        }
      },
      handleTouchstart(event) {
        this.mousePos = this.getTouchPos(event);
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchend(event) {
        let mouseEvent = new MouseEvent('mouseup', {});
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchmove(event) {
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousemove', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      getMousePos(mouseEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        };
      },
      // Get the position of a touch relative to the canvas
      getTouchPos(touchEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        };
      },
      limitText(count) {
        return `and ${count} other kode penyakit`;
      },
      // to get kode_penyakit datas from backend
      debounceSearch: debounce(function(val, type) {
        if (this.keyword != val && this.checkValueData(val)) {
          this.keyword = val;
          this.asyncFind(val, type)
        }
      }, 500),
      asyncFind(query, type = 'secondary') {
        let self = this;
        this.isLoading = true;

        if (this.saving_params.is_bpjs) {
          this.$axios.get(`bpjs/diagnosa?klinik_id=${this.getKlinikId}&kode=${query}&first_row=0&limit=100`)
          .then(res => {
            const { metaData, response } = res.data;

            if (metaData.code != 200) {
              self.isLoading = false;
              return;
            }
            const kode_penyakit = response.list.map(item => ({
              id: item.kdDiag,
              kode: item.kdDiag,
              description: item.nmDiag,
              nonSpesialis: item.nonSpesialis,
            }));
            if (kode_penyakit.length > 0) {
              if (type == 'primary') self.kodePenyakitPrimer = kode_penyakit
              else {
                if (this.selectedKodePenyakitPrimer) self.kodePenyakit = kode_penyakit.filter(kp => kp.kode != this.selectedKodePenyakitPrimer.kode);
                else  self.kodePenyakit = kode_penyakit;
              }
            }
            self.isLoading = false;
          })
          .catch(err => {
            self.isLoading = false;
          });
        } else {
          let urlKodePenyakit = `kode_penyakit?name=${query}`
          if(this.hasEncounterSatusehat) {
            urlKodePenyakit = urlKodePenyakit + '&satusehat=true'
          }
          this.$axios
          .get(urlKodePenyakit)
          .then(response => {
            let res = response.data;

            if (!res.status) {
              self.isLoading = false;
              return;
            }
            const kode_penyakit = res.data.kode_penyakit.data;
            if (kode_penyakit) {
              if (type == 'primary') self.kodePenyakitPrimer = kode_penyakit
              else {
                if (this.selectedKodePenyakitPrimer) self.kodePenyakit = kode_penyakit.filter(kp => kp.kode != this.selectedKodePenyakitPrimer.kode);
                else  self.kodePenyakit = kode_penyakit;
              }
            }
            self.isLoading = false;
          })
          .catch(err => {
            self.isLoading = false;
          });
        }
      },
      // to get kondisi datas from backend
      debounceCondition: debounce(function(val) {
        this.keywordCondition = val;
        this.asyncFindCondition(val);
      }, 500),
      asyncFindCondition(query) {
        this.isLoadingCondition = true;

        let search = '';
        if (this.checkValueData(query)) {
          search = `?q=${query}`;
        }

        this.$axios.get(`condition${search}`)
        .then(response => {
          const { status, data } = response.data;

          if (!status) {
            this.isLoadingCondition = false;
            return;
          }
          
          this.optionCondition = data.data.map(d => ({
            ...d,
            label: `${d.code} - ${d.name} (${d.description})`,
          }));
          this.isLoadingCondition = false;
        })
        .catch(err => {
          this.isLoadingCondition = false;
        });
      },
      penColor(color) {
        this.ctx.strokeStyle = color;
      },
      clear() {
        this.canvas.width = this.canvas.width;
        this.isDrawing = false;
        this.isColorActive = 'black';
      },
      setDrawPostData(type) {
        if (type == 'pen') {
          this.isPen = true;
          this.isHidden = false;
          this.isDrawing = true;
        } else if (type == 'eraser') {
          this.isPen = false;
          this.isHidden = false;
        } else {
          this.isPen = false;
          this.isHidden = true;
        }
        this.isActive = type;
        this.updatePostData({ key: 'diagnosa_is_draw', value: this.isDrawing });
      },
      setPrognosa($event) {
        let value = null;
        if ($event && typeof $event == 'object') {
          value = $event.value;
          this.prognosa.error = false;
        } else this.prognosa.error = true;
        this.updatePostData({ key: 'kd_prognosa', value: value });
      },
    },
  };
</script>

<style>
  .form-diagnosa .quill-editor .ql-container.ql-snow .ql-editor.ql-blank::before {
    content: 'Anda dapat menuliskan diagnosis disini jika Anda tidak menemukan Kode Diagnosis yang diinginkan, maupun keterangan lainnya' !important;
  }
  #diagnosa-canvas {
    touch-action: none;
  }
  .__select-prognosa
    .vs__dropdown-toggle
    .vs__selected-options
    .vs__search::placeholder {
    color: #d1d2db !important;
    font-size: 14px !important;
    font-weight: 500;
  }
  .__select-prognosa .vs__dropdown-toggle {
    height: 42px !important;
  }
  .__select-prognosa .vs__dropdown-menu {
    max-height: 170px !important;
    position: relative;
  }
  .pen-width {
    width: 125px !important;
  }
  .multiselect_secondary .multiselect .multiselect__content-wrapper {
    max-height: 200px !important;
    position: relative !important;
  }
  .multiselect_primary .multiselect__content-wrapper {
      max-height: 190px !important;
  }
  .form-diagnosa .quill-editor .ql-toolbar {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .form-diagnosa .quill-editor .ql-container {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .form-diagnosa .quill-editor .ql-toolbar {
    zoom: 75%;
  }
  .form-diagnosa .quill-editor .ql-container {
    color: #505050;
    font-size: 14px;
  }
  @media screen and (max-width: 1400px) {
    .form-diagnosa .quill-editor .ql-toolbar {
      zoom: 70%;
    }
    .form-diagnosa .quill-editor .ql-container {
      color: #505050;
      font-size: 12px;
    }
  }
  @media screen and (max-width: 1024px) {
    .form-diagnosa .quill-editor .ql-toolbar {
      zoom: 60%;
    }
    .form-diagnosa .quill-editor .ql-container {
      color: #505050;
      font-size: 10px;
    }
  }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>